import { ApiService } from "./apiService"


export const MapService = function(){
   
    return{
        getAllLocations: () => {
            return ApiService.get(
                '/api/items/locations/?fields=*,translations.*&filter[status][_eq]=published'
            );
        },
        searchLocation: (value: string) => {
            return ApiService.get(
                `/api/items/locations?search=${value}&fields=translations.*&filter[status][_eq]=published`
            );
        },
    }
}
